const handleDDCEvent = (event, ddcEventData) => {
	let eventObject;
	if (ddcEventData?.eventType) {
		eventObject = ddcEventData.eventType(event);
	}
	return eventObject;
};

export default handleDDCEvent;
